import {CIRF_NAME_KEYS} from "../shared/constants";
import {BaseEntity} from "../common/base-entity";

export class CirfNavigation {

    navigationSections: NavigationSection[] = [];

    selectedClientIndex: number;
    selectedTopicKey: string;
    selectedSectionKey: string;
    selectedNewMortgageIndex: number;
    selectedExistingMortgageIndex: number;

    resetSelection(): void {
        this.selectedClientIndex = -1;
        this.selectedTopicKey = null;
        this.selectedSectionKey = null;
        this.selectedNewMortgageIndex = -1;
        this.selectedExistingMortgageIndex = -1;
    }

    isClientNotesTopic() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.clientNotesTopic.key;
    }

    isIdVerification1() : boolean {
        return this.selectedSectionKey == CIRF_NAME_KEYS.idVerification1.key;
    }

    isIdVerification2() : boolean {
        return this.selectedSectionKey == CIRF_NAME_KEYS.idVerification2.key;
    }

    isTransactionDetailsTopic() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.transactionDetails.key;
    }

    isClientProfileSection() : boolean {
        return this.selectedSectionKey == CIRF_NAME_KEYS.personalDetails.key;
    }

    isMatterNotesSection() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.additionalNotes.key && this.selectedSectionKey == CIRF_NAME_KEYS.matterNotes.key;
    }

    isInsuranceSection() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.additionalNotes.key && this.selectedSectionKey == CIRF_NAME_KEYS.newInsuranceDetails.key;
    }

    isNewMortgageNoteSection() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.newMortgageNoteTopic.key && this.selectedSectionKey == CIRF_NAME_KEYS.newMortgageNotes.key;;
    }

    isExistingMortgageNoteSection() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.existingMortgageNoteTopic.key && this.selectedSectionKey == CIRF_NAME_KEYS.existingMortgageNotes.key;;
    }

    isAdditionalAttachmentsSection() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.additionalNotes.key && this.selectedSectionKey == CIRF_NAME_KEYS.additionalAttachments.key;
    }

    isReviewSubmitSection() : boolean {
        return this.selectedTopicKey == CIRF_NAME_KEYS.additionalNotes.key && this.selectedSectionKey == CIRF_NAME_KEYS.reviewSubmit.key;
    }
}

export class NavigationSection extends BaseEntity{
    clientIndex: number;
    topicKey: string;
    sectionKey: string;
    newMortgageIndex: number;
    existingMortgageIndex: number;

    isReviewSubmitSection() : boolean {
        return this.topicKey == CIRF_NAME_KEYS.additionalNotes.key && this.sectionKey == CIRF_NAME_KEYS.reviewSubmit.key;
    }

    isIdVerification2() : boolean {
        return this.sectionKey == CIRF_NAME_KEYS.idVerification2.key;
    }

}
